var IS_VERTICAL = {
    COLUMNS: true,
    ROWS: false,
};
export default IS_VERTICAL;
//# sourceMappingURL=isVertical.js.map